/**
 * Centralized label mappings for grants module entities.
 * Used in both list pages and detail pages for consistency.
 */

export const programTypeLabels: Record<string, string> = {
  EU_NATIONAL: "UE - Krajowy",
  EU_REGIONAL: "UE - Regionalny",
  NATIONAL_FUND: "Krajowy",
};

export const competitionStatusLabels: Record<string, string> = {
  ANNOUNCED: "Zapowiedziany",
  ACTIVE: "Aktywny",
  CLOSING: "Zamykany",
  CLOSED: "Zamknięty",
};

export const competitionStatusColors: Record<string, string> = {
  ANNOUNCED: "bg-blue-100 text-blue-800",
  ACTIVE: "bg-green-100 text-green-800",
  CLOSING: "bg-amber-100 text-amber-800",
  CLOSED: "bg-neutral-200 text-neutral-800",
};

export const operatorTypeLabels: Record<string, string> = {
  PUP: "PUP",
  REGIONAL: "Regionalny",
  PROJECT: "Projektowy",
  DIRECT: "Bezpośredni",
};

/**
 * Action type badge colors and labels for recommendations
 */
export const ACTION_BADGES: Record<
  string,
  { label: string; className: string; breadcrumbLabel?: string }
> = {
  create_new: {
    label: "Nowy nabór",
    breadcrumbLabel: "Nowy nabór",
    className: "bg-green-100 text-green-800 border-green-200",
  },
  update_existing: {
    label: "Aktualizacja",
    breadcrumbLabel: "Aktualizacja",
    className: "bg-yellow-100 text-yellow-900 border-yellow-200",
  },
  link_to_existing: {
    label: "Powiązanie",
    breadcrumbLabel: "Powiązanie",
    className: "bg-blue-100 text-blue-800 border-blue-200",
  },
};

/**
 * Call status labels and colors
 * @see docs/specifications/2026-01-30-recommendation-details-project-context.md
 */
export const CALL_STATUS_LABELS: Record<string, string> = {
  OPEN: "Otwarty",
  CLOSED: "Zamknięty",
  ANNOUNCED: "Ogłoszony",
  SUSPENDED: "Zawieszony",
  CANCELLED: "Anulowany",
  UNDER_REVIEW: "Rozpatrywany",
  RESOLVED: "Rozstrzygnięty",
  EXPIRED: "Wygasły",
};

export const CALL_STATUS_COLORS: Record<string, string> = {
  OPEN: "bg-green-100 text-green-800",
  CLOSED: "bg-neutral-200 text-neutral-800",
  ANNOUNCED: "bg-blue-100 text-blue-800",
  SUSPENDED: "bg-yellow-100 text-yellow-900",
  CANCELLED: "bg-red-100 text-red-800",
  UNDER_REVIEW: "bg-cyan-100 text-cyan-800",
  RESOLVED: "bg-neutral-200 text-neutral-800",
  EXPIRED: "bg-neutral-200 text-neutral-800",
};

/**
 * Recommendation status labels and colors
 */
export const RECOMMENDATION_STATUS_LABELS: Record<string, string> = {
  pending_review: "Do przejrzenia",
  approved: "Zatwierdzona",
  rejected: "Odrzucona",
  auto_approved: "Auto-zatwierdzona",
};

export const RECOMMENDATION_STATUS_COLORS: Record<string, string> = {
  pending_review: "bg-yellow-100 text-yellow-900",
  approved: "bg-green-100 text-green-800",
  rejected: "bg-red-100 text-red-800",
  auto_approved: "bg-blue-100 text-blue-800",
};
